const container = "_container_19o42_10";
const input = "_input_19o42_24";
const ui = "_ui_19o42_34";
const styles = {
  container,
  input,
  ui
};
export {
  container,
  styles as default,
  input,
  ui
};
//# sourceMappingURL=Toggle.module.css.js.map
